import React from "react";
import ReactDOM from "react-dom/client";
import { migrateOwnerPersistKeys } from "@lib/ownerPersistKeys";
import "@styles/index.css";
import { App } from "@app/App";

migrateOwnerPersistKeys();

ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
